/* eslint-disable max-len */
/* eslint-disable camelcase */
import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import labels from '../i18n';

const VacancyComponent = (props) => {
  const { vacancy, lang, mode } = props;
  const {
    link,
    deadline,
    deadline_date,
    end,
    end_date,
    faculty,
    hours,
    location,
    start,
    start_date,
    title,
    teaser,
  } = vacancy;

  const dateFormat = `D${lang === 'da' ? '.' : ''} MMM YYYY`;
  const dateShortFormat = `D${lang === 'da' ? '.' : ''} MMM`;
  moment.locale(lang);

  const deadlineText = deadline_date ? moment(deadline_date).format(dateShortFormat) : moment(deadline).format(dateShortFormat);
  const startText = start_date ? moment(start_date).format(dateFormat) : moment(start).format(dateFormat);
  const endText = end_date ? moment(end_date).format(dateFormat) : moment(end).format(dateFormat);

  return (
    <li className={vacancy.new ? 'new' : null}>
      <a href={link}>
        <div>
          <span>{labels[lang].list.deadline}</span>
          <span>{deadlineText}</span>
        </div>
        <div>
          <span>{`${location.name}${mode === 'department' ? '' : ','} `}</span>
          {(() => {
            if (mode !== 'department') {
              return (
                <span className="avoid-wrap">{`${faculty}`}</span>
              );
            }
            return null;
          })()}
          <h2>{title}</h2>
          {(() => {
            if (mode === 'department') {
              return <p>{teaser}</p>;
            }
            return null;
          })()}
        </div>
        <div>
          {(() => {
            if (!end) {
              return (
                <span>
                  {`${labels[lang].list.expected}: `}
                  <span className="no-wrap">{startText}</span>
                </span>
              );
            }
            return (
              <span>
                {`${labels[lang].list.timelimit}: `}
                <span className="avoid-wrap">
                  <span className="no-wrap">{startText}</span>
                  {' - '}
                  <span className="no-wrap">{endText}</span>
                </span>
              </span>
            );
          })()}
          {(() => {
            if (hours === 37) {
              return <span>{labels[lang].list.fulltime}</span>;
            }
            if (hours === 0) {
              return <span>{labels[lang].list.parttimeFull}</span>;
            }
            let hrsLbl = `${hours}`;
            if (lang === 'da') {
              hrsLbl = hrsLbl.replace('.', ',');
            }
            return (
              <span>
                {`${labels[lang].list.parttime}: `}
                <span className="no-wrap">
                  {`${hrsLbl} ${labels[lang].list.hours} ${labels[lang].list.prWeek}`}
                </span>
              </span>
            );
          })()}
        </div>
      </a>
    </li>
  );
};

VacancyComponent.propTypes = {
  vacancy: PropTypes.shape({
    area: PropTypes.number,
    deadline: PropTypes.number.isRequired,
    deadline_date: PropTypes.instanceOf(Date),
    end: PropTypes.number,
    end_date: PropTypes.instanceOf(Date),
    faculty: PropTypes.string.isRequired,
    hours: PropTypes.number.isRequired,
    id: PropTypes.number.isRequired,
    location: PropTypes.shape({
      name: PropTypes.string.isRequired,
      zip: PropTypes.number.isRequired,
    }).isRequired,
    mode: PropTypes.string.isRequired,
    start: PropTypes.number.isRequired,
    start_date: PropTypes.instanceOf(Date),
    title: PropTypes.string.isRequired,
    link: PropTypes.string.isRequired,
    teaser: PropTypes.string.isRequired,
    new: PropTypes.bool.isRequired,
  }).isRequired,
  lang: PropTypes.string.isRequired,
  mode: PropTypes.string.isRequired,
};

VacancyComponent.displayName = 'VacancyComponent';
export default VacancyComponent;
